import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const SiswaForm = ({ token }) => {
  const [nama, setNama] = useState('');
  const [nis, setNis] = useState('');
  const [nisn, setNisn] = useState('');
  const [kelas, setKelas] = useState('');
  const [tglLahir, setTglLahir] = useState('');
  
  // BIODATA TAMBAHAN
  const [tempatLahir, setTempatLahir] = useState('');
  const [jenisKelamin, setJenisKelamin] = useState('L');
  const [agama, setAgama] = useState('Islam');
  const [alamat, setAlamat] = useState('');
  const [noHpOrtu, setNoHpOrtu] = useState('');

  const [kelasList, setKelasList] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchKelas();
    if (id) fetchSiswa();
  }, [id]);

  const fetchKelas = async () => {
    try {
      const res = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/kelas', { headers: { Authorization: `Bearer ${token}` } });
      setKelasList(res.data);
    } catch (err) {}
  };

  const fetchSiswa = async () => {
    try {
      const res = await axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/siswa/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = res.data;
      setNama(data.nama);
      setNis(data.nis);
      setNisn(data.nisn);
      setKelas(data.kelas);
      setTglLahir(data.tgl_lahir);
      // Set Biodata Tambahan
      setTempatLahir(data.tempat_lahir || '');
      setJenisKelamin(data.jenis_kelamin || 'L');
      setAgama(data.agama || 'Islam');
      setAlamat(data.alamat || '');
      setNoHpOrtu(data.no_hp_ortu || '');
    } catch (err) {}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { 
        nama, nis, nisn, kelas, 
        tgl_lahir: tglLahir,
        tempat_lahir: tempatLahir,
        jenis_kelamin: jenisKelamin,
        agama,
        alamat,
        no_hp_ortu: noHpOrtu
    };

    try {
      if (id) {
        await axios.put(`https://sijapan.sman10fajarharapan.sch.id/api/siswa/${id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
        Swal.fire('Berhasil', 'Data siswa diperbarui', 'success');
      } else {
        await axios.post('https://sijapan.sman10fajarharapan.sch.id/api/siswa', payload, { headers: { Authorization: `Bearer ${token}` } });
        Swal.fire('Berhasil', 'Siswa baru ditambahkan', 'success');
      }
      navigate('/siswa');
    } catch (err) {
      Swal.fire('Gagal', 'Terjadi kesalahan sistem', 'error');
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '20px auto', padding: '30px', background: 'white', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
      <h2 style={{ color: '#334155', marginBottom: '25px', textAlign:'center' }}>{id ? '✏️ Edit Data Siswa' : '➕ Tambah Siswa Baru'}</h2>
      <form onSubmit={handleSubmit}>
        
        {/* BAGIAN 1: DATA AKADEMIK */}
        <h4 style={{borderBottom:'2px solid #f1f5f9', paddingBottom:'10px', color:'#4361ee'}}>🎓 Data Akademik</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
                <label style={labelStyle}>NIS (Username Login)</label>
                <input type="text" value={nis} onChange={e => setNis(e.target.value)} required style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>NISN</label>
                <input type="text" value={nisn} onChange={e => setNisn(e.target.value)} required style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Nama Lengkap</label>
                <input type="text" value={nama} onChange={e => setNama(e.target.value)} required style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Kelas</label>
                <select value={kelas} onChange={e => setKelas(e.target.value)} required style={inputStyle}>
                    <option value="">-- Pilih Kelas --</option>
                    {kelasList.map(k => <option key={k.id} value={k.nama_kelas}>{k.nama_kelas}</option>)}
                </select>
            </div>
        </div>

        {/* BAGIAN 2: BIODATA PRIBADI */}
        <h4 style={{borderBottom:'2px solid #f1f5f9', paddingBottom:'10px', color:'#4361ee', marginTop:'30px'}}>👤 Biodata Pribadi</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
                <label style={labelStyle}>Tempat Lahir</label>
                <input type="text" value={tempatLahir} onChange={e => setTempatLahir(e.target.value)} style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Tanggal Lahir (Password Default)</label>
                <input type="date" value={tglLahir} onChange={e => setTglLahir(e.target.value)} required style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Jenis Kelamin</label>
                <select value={jenisKelamin} onChange={e => setJenisKelamin(e.target.value)} style={inputStyle}>
                    <option value="L">Laki-laki</option>
                    <option value="P">Perempuan</option>
                </select>
            </div>
            <div>
                <label style={labelStyle}>Agama</label>
                <select value={agama} onChange={e => setAgama(e.target.value)} style={inputStyle}>
                    <option value="Islam">Islam</option>
                    <option value="Kristen">Kristen</option>
                    <option value="Katolik">Katolik</option>
                    <option value="Hindu">Hindu</option>
                    <option value="Buddha">Buddha</option>
                    <option value="Konghucu">Konghucu</option>
                </select>
            </div>
        </div>

        {/* BAGIAN 3: KONTAK */}
        <h4 style={{borderBottom:'2px solid #f1f5f9', paddingBottom:'10px', color:'#4361ee', marginTop:'30px'}}>📞 Kontak & Alamat</h4>
        <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>No. HP Orang Tua / Wali</label>
            <input type="text" value={noHpOrtu} onChange={e => setNoHpOrtu(e.target.value)} placeholder="Contoh: 08123456789" style={inputStyle} />
        </div>
        <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Alamat Lengkap</label>
            <textarea value={alamat} onChange={e => setAlamat(e.target.value)} rows="3" style={{...inputStyle, height:'auto'}}></textarea>
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '30px' }}>
            <button type="submit" style={{ flex: 1, padding: '12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor:'pointer' }}>💾 Simpan Data</button>
            <button type="button" onClick={() => navigate('/siswa')} style={{ flex: 1, padding: '12px', background: '#e2e8f0', color: '#334155', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor:'pointer' }}>Batal</button>
        </div>
      </form>
    </div>
  );
};

const labelStyle = { display: 'block', marginBottom: '8px', fontWeight: '600', color: '#64748b', fontSize:'14px' };
const inputStyle = { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', boxSizing:'border-box' };

export default SiswaForm;